angular.module('impactx.search').controller('ProductItemCtrl', [
    'ProductItemService',
    'AppConfiguration',
    'panelService',
    'ExtendedProductTooltipService',
    ProductItemController
]);

function ProductItemController(ProductItemService, AppConfiguration, panelService, ExtendedProductTooltipService) {
    var self = this;
    
    self.openImageGallery = function (event) {
        ProductItemService.openGallery(event, self.product);
    };

    self.redirectToDetails = function () {
        ExtendedProductTooltipService.stopTimer();
        ProductItemService.redirectToDetails(self.product, self.vCatId, self.highlightSearchText)
    };

    self.showExtendedTooltip = function (event, product) {
        ExtendedProductTooltipService.open(event, product, 500);
    };

    self.closeExtendedTooltip = function () {
        ExtendedProductTooltipService.close();
    };

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');
    self.showFirstDeliveryDate = AppConfiguration.get('showFirstDeliveryDate');
    self.getProductPanelColor = panelService.getProductPanelColor;
    self.useDescriptionAsTooltip = AppConfiguration.get('useProductDescriptionAsTooltip');
    self.highlightSearchText = AppConfiguration.get('useSearchHighlighting');
    self.showVCatalogInProductSearch = AppConfiguration.get('showVCatalogInProductSearch');
}